var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region Student - Ctor
    ns.Student = function Student(selectedSchedules) {
        this.initialize(selectedSchedules);
    };
    // #endregion

    // #region Student - Inheritance

    ns.Student.prototype = new ns.ScheduleResourceBase();
    ns.Student.prototype.constructor = ns.Student;
    ns.Student.prototype.parent = ns.ScheduleResourceBase.prototype;

    // #endregion

})(webooker_acivity_models);